import Alert from '@bees-web/nfa-components-react/lib/atoms/Alert'
import Collapse from '@bees-web/nfa-components-react/lib/molecules/Collapse'
import React, { FC } from 'react'
//import { getCookie } from '../../utils/getCookie'

export interface ErrorStatementProps {
  title?: string
  children?: React.ReactNode
}

const ErrorStatement: FC<ErrorStatementProps> = ({ title = '', children }) => {
  const stage = process.env.STAGE?.toLocaleLowerCase() || 'prod'
  const isNonProd = stage !== 'prod' && stage !== 'uat'

  // TODO: Add debug cookie check to context
  //const hasDebugCookie = getCookie('debug') === process.env.BUILD_BUILDID
  const hasDebugCookie = false

  if (isNonProd || hasDebugCookie) {
    return (
      <Alert attributes={{ type: 'error', isDismissible: true }}>
        <Collapse attributes={{ title }}>{children}</Collapse>
      </Alert>
    )
  }

  return <></>
}

export default ErrorStatement
